import { get, post, deleteRequest } from 'helpers/api';
import { isBlank } from 'helpers/string_helpers';
import { pickBy } from 'lodash';

import { getSavedSearchIndexPath } from '../selectors/paths';
import { getDeleteSavedSearch } from '../selectors/saved_searches';

import { toggleAlert, switchTab } from './ui';
import { setFullQuery } from './query';
import { retrieveRecords } from './search';
import { setUserBounds, enableAutoBoundsSearching } from './coordinates';

export const SET_SAVED_SEARCHES = 'SET_SAVED_SEARCHES';
export const setSavedSearches = searches => ({
  searches,
  type: SET_SAVED_SEARCHES
});

export const START_LOAD_SEARCHES = 'START_LOAD_SEARCHES';
export const startLoadSearches = () => ({
  type: START_LOAD_SEARCHES
});

export const START_DELETE_SEARCH = 'START_DELETE_SEARCH';
export const startDeleteSearch = search => ({
  search,
  type: START_DELETE_SEARCH
});

export const END_DELETE_SEARCH = 'END_DELETE_SEARCH';
export const endDeleteSearch = () => ({
  type: END_DELETE_SEARCH
});

export const loadSearchQuery = search => (
  (dispatch) => {
    const query = filterQuery(search.query);
    dispatch(setFullQuery(query));
    if (Object.keys(search.coordinates).length > 0) {
      dispatch(switchTab("maps"));
      dispatch(enableAutoBoundsSearching());
      dispatch(setUserBounds(search.coordinates.userBounds));
    }
    dispatch(retrieveRecords());
  }
);

export const loadSavedSearches = () => (
  (dispatch, getState) => {
    const path = getSavedSearchIndexPath(getState());
    dispatch(startLoadSearches());

    return get(path, { params: { modelType: "Research::Property" } }).then((searches) => {
      dispatch(setSavedSearches(searches));
    });
  }
);

export const saveSavedSearch = (name) => {
  return (dispatch, getState) => {
    const state = getState();
    const path = getSavedSearchIndexPath(state);
    const query = filterQuery(state.query);
    const { autoBoundsSearchingEnabled, mapBounds, ...filteredCoordinates } = { ...state.coordinates };

    return post(path, {
      savedSearch: {
        name: name,
        query: query,
        modelType: "Research::Property",
        coordinates: filteredCoordinates
      }
    }).then(({ message }) => {
      dispatch(loadSavedSearches());
      dispatch(toggleAlert(message, false));
    }).catch(() => {
      dispatch(toggleAlert("This search already exists. Please try a new query", true));
    });
  };
};

export const deleteSavedSearch = () => (
  (dispatch, getState) => {
    const path = getSavedSearchIndexPath(getState());
    const deletedSavedSearch = getDeleteSavedSearch(getState());
    return deleteRequest(`${path}/${deletedSavedSearch.id}`).then(({ message }) => {
      dispatch(loadSavedSearches());
      dispatch(endDeleteSearch());
      dispatch(toggleAlert(message, true));
    }).catch(() => {
      dispatch(toggleAlert("Unable to delete search.", true));
    });
  }
);

const filterNestedObject = (obj) => {
  const filteredObject = pickBy(obj, (value) => {
    if (Array.isArray(value)) return value.length > 0;
    return !isBlank(value);
  });

  const isObjectEmpty = Object.keys(filteredObject).length == 0;
  return isObjectEmpty ? null : filteredObject;
};

const filterQuery = (query) => {
  const { filtersApplied, propertyPage, ...filteredQuery } = query;

  filteredQuery.addressFilter = filterNestedObject(filteredQuery.addressFilter);
  filteredQuery.industrialFilter = filterNestedObject(filteredQuery.industrialFilter);
  filteredQuery.multifamilyFilter = filterNestedObject(filteredQuery.multifamilyFilter);
  filteredQuery.propertyFilter = filterNestedObject(filteredQuery.propertyFilter);
  filteredQuery.saleFilter = filterNestedObject(filteredQuery.saleFilter);

  return filterNestedObject(filteredQuery);
};
